



































import { Component, Prop } from 'vue-property-decorator';
import { PriceDto, ProductBasePrice, ProductNetFillQuantity } from '@eurogast/hub-client-typescript';
import { BFOrderItem } from '@/services/BfOrderDeserializer';
import { ConfigService } from '@/services/ConfigService';
import ProductComponentBase from '@/common/ProductComponentBase';
import { UnitDefinition } from '@/services/ProductDeserializer';

@Component({})
export default class BestFriendOrderItem extends ProductComponentBase {
  get currentUnit(): UnitDefinition {
    return this.item ? this.item.unit : null;
  }

  set currentUnit(ignored: UnitDefinition) {
    // no-op
  }

  get currentAmount(): number {
    return this.item ? this.item.amount : 0;
  }

  get bulkPrices(): PriceDto[] {
    return this.item ? this.item.bulkPrices : [];
  }

  get units(): UnitDefinition[] {
    if (!this.item) {
      return [];
    }
    return [this.item.unit, this.item.storageUnit].filter((it) => it !== null);
  }

  get basePrice(): ProductBasePrice {
    return null;
  }

  get netFillQuantity(): ProductNetFillQuantity {
    return null;
  }

  get sku(): string {
    if (this.item && this.item.sku) {
      return this.item.sku;
    } else {
      return '';
    }
  }

  get unitName(): string {
    if (this.item) {
      return this.item.unit.name;
    } else {
      return '';
    }
  }

  get itemName(): string {
    if (this.item && this.item.name) {
      return this.item.name;
    } else {
      return '';
    }
  }

  get thumbnailPath() {
    return (this.item && this.item.imagePath) ? `${ConfigService.getAssetBaseUrl()}/${this.item.imagePath}` : '';
  }

  get hasDiscount(): boolean {
    return !!(this.currentBulkPrice && this.currentBulkPrice.attachedDiscount) &&
      ConfigService.isHighlightDiscounts();
  }

  @Prop()
  public item: BFOrderItem;
}
